import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '~/redux/store'
import { TMathCaptcha, TAuthTypes } from '~/auth/types/auth.types'

interface ReCaptchaState {
  captcha: TMathCaptcha
  authType: TAuthTypes | null
}

const initialState: ReCaptchaState = {
  captcha: {
    challenge: '',
    answer: '',
  },
  authType: null,
}

const slice = createSlice({
  name: 'recaptcha',
  initialState,
  reducers: {
    resetCaptcha() {
      return initialState
    },
    setCaptcha(state, { payload }: PayloadAction<TMathCaptcha>) {
      state.captcha = payload
    },
    setAuthType(state, { payload }: PayloadAction<TAuthTypes>) {
      state.authType = payload
    },
  },
})

// SELECTORS
export const selectCaptcha = (state: RootState): TMathCaptcha => state.recaptcha.captcha
export const selectAuthType = (state: RootState): TAuthTypes | null => state.recaptcha.authType

// ACTIONS
export const { resetCaptcha, setCaptcha, setAuthType } = slice.actions

export default slice.reducer
